import ProtectedAuthPages from "@components/Routes/ProtectedAuthPages"
import ProtectedRoute from "@components/Routes/ProtectedRoute"
import RouteVerifyEmail from "@components/Routes/RouteVerifyEmail"
import ShouldBeAuthenticatedRoute from "@components/Routes/ShouldBeAuthenticated"
import ScheduleCall from "@pages/apa/ScheduleCall"
import AuthActions from "@pages/authenticate/AuthActions"
import Entry from "@pages/authenticate/Entry"
import ForgotPassword from "@pages/authenticate/ForgotPassword"
import Login from "@pages/authenticate/Login"
import Signup from "@pages/authenticate/Signup"
import Dashboard from "@pages/dashboard/Dashboard"
import FactFind from "@pages/fact_find/FactFind"
import FactFindFinancialDetails from "@pages/fact_find/FactFindFinancialDetails"
import FactFindPersonalDetails from "@pages/fact_find/FactFindPersonalDetails"
import FactFindQualification from "@pages/fact_find/FactFindQualification"
import FactFindQualificationPost from "@pages/fact_find/FactFindQualificationPost"
import FactFindRiskReward from "@pages/fact_find/FactFindRiskReward"
import FactFindWelcome from "@pages/fact_find/FactFindWelcome"
import ActivityInformation from "@pages/pension_application/ActivityInformation"
import ActivityInformationSubmited from "@pages/pension_application/ActivityInformationSubmited"
import AddActivityDetails from "@pages/pension_application/AddActivityDetails"
import CompletePRSAForm from "@pages/pension_application/CompletePRSAForm"
import PensionApplication from "@pages/pension_application/PensionApplication"
import SignContract from "@pages/pension_application/SignContract"
import VerifyIdentity from "@pages/pension_application/VerifyIdentity"
import ZurichProvider from "@pages/pension_application/ZurichProvider"
import SaveQuoteStep from "@pages/pension_calculator/SaveQuoteStep"
import ProfileManage from "@pages/profile_manage/ProfileManage"
import RecommendationsDetails from "@pages/recommendations/RecommendationsDetails"
import EmailVerification from "@pages/verify/EmailVerification"
import RequestFollowUp from "@pages/verify/RequestFollowUp"
import { Outlet, createBrowserRouter } from "react-router-dom"
import Layout from "./components/layout/Layout"
import PensionCalculator from "./pages/pension_calculator/PensionCalculator"
import PensionStep from "./pages/pension_calculator/PensionStep"
import PennySpace from "./pages/penny-space/PennySpace"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            element: <FactFind />,
            path: "/fact-find",
          },
          {
            element: <FactFindWelcome />,
            path: "/fact-find/welcome",
          },
          {
            element: <FactFindQualification />,
            path: "/fact-find/qualification",
          },
          {
            element: <FactFindQualificationPost />,
            path: "/fact-find/qualification/message",
          },
          {
            element: <FactFindPersonalDetails />,
            path: "/fact-find/personal-details",
          },
          {
            element: <FactFindFinancialDetails />,
            path: "/fact-find/financial-details",
          },
          {
            element: <FactFindRiskReward />,
            path: "/fact-find/risk-reward",
          },
          {
            element: <ScheduleCall />,
            path: "/schedule-call",
          },
          {
            element: <ProfileManage />,
            path: "/my-profile",
          },
          {
            element: <PennySpace />,
            path: "/penny-space",
          },
          {
            path: "/recommendations/details/:zurich_details",
            element: <RecommendationsDetails />,
          },
          {
            path: "/pension-application",
            children: [
              {
                index: true,
                element: <PensionApplication />,
              },
              {
                path: "activity-details",
                children: [
                  {
                    path: "add-details",
                    element: <AddActivityDetails />,
                  },
                ],
              },
              {
                path: "activity-information",
                children: [
                  {
                    index: true,
                    element: <ActivityInformation />,
                  },
                  {
                    path: "success",
                    element: <ActivityInformationSubmited />,
                  },
                ],
              },
              {
                element: <VerifyIdentity />,
                path: "verify-identity",
              },
              {
                path: "prsa-form",
                children: [
                  {
                    index: true,
                    element: <CompletePRSAForm />,
                  },
                  {
                    path: "zurich-provider",
                    element: <ZurichProvider />,
                  },
                ],
              },
              {
                path: "sign-contract",
                element: <SignContract />,
              },
            ],
          },
        ],
      },
      {
        element: <ShouldBeAuthenticatedRoute />,
        children: [
          {
            path: "/verify/request-followup",
            element: <RequestFollowUp />,
          },
        ],
      },
      {
        element: <ProtectedAuthPages />,
        children: [
          {
            path: "/entry",
            element: <Entry />,
          },
          {
            path: "/login",
            element: <Login />,
          },
          {
            path: "/signup",
            element: <Signup />,
          },
          {
            path: "/forgot-password",
            element: <ForgotPassword />,
          },
        ],
      },
      {
        element: <RouteVerifyEmail />,
        path: "/verify",
        children: [
          {
            path: "email-verification",
            element: <EmailVerification />,
          },
        ],
      },
      {
        path: "/pension-calculator",
        element: <Outlet />,
        id: "pensionrouter",
        children: [
          {
            index: true,
            element: <PensionCalculator />,
          },
          { path: "calculator", element: <PensionStep /> },
          {
            path: "quote",
            element: <SaveQuoteStep />,
          },
        ],
      },
      {
        path: "/auth/action",
        element: <AuthActions />,
      },
    ],
  },
])

export default router;
